import { createSelector } from 'reselect';

const selectTemplatePage = (state) => {
  return state.templatePage;
};

const makeSelectTemplates = () =>
  createSelector(selectTemplatePage, (state) => {
    return state.templates;
  });

const makeSelectIsLoadingTemplates = () =>
  createSelector(selectTemplatePage,
    (state) => state.isLoadingCategoryPageTemplates
  );

const makeSelectTotalPage = () =>
  createSelector(selectTemplatePage, (state) => state.totalCategoryPageTemplates
  );

const makeSelectCurrentPage = () =>
  createSelector(selectTemplatePage, (state) => state.currentPageOfCategoryPageTemplate);

const makeSelectNumberPage = () =>
  createSelector(selectTemplatePage, (state) => state.numberPagesOfCategoryPage);

export {
  selectTemplatePage,
  makeSelectCurrentPage,
  makeSelectTemplates,
  makeSelectIsLoadingTemplates,
  makeSelectTotalPage,
  makeSelectNumberPage
};
